<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate">Corregir OOTT</span>
            <button
                style="float: right"
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form mt-8" [formGroup]="formCorreccion" autocomplete="off">
            <mat-form-field class="full-width mt-8">
                <mat-label>Observaciones</mat-label>
                <textarea
                    matInput
                    formControlName="observaciones"
                    rows="3"
                    placeholder="Indique las observaciones que se deben corregir"
                ></textarea>
                <mat-hint
                    >{{ observaciones.value?.length }} /
                    {{ largoMaximo }}</mat-hint
                >

                <mat-error *ngIf="observaciones.hasError('minlength')">
                    Debe ingresar al menos
                    {{ observaciones.getError("minlength").requiredLength }}
                    caracteres
                </mat-error>
                <mat-error *ngIf="observaciones.hasError('maxlength')">
                    Máximo
                    {{ observaciones.getError("maxlength").requiredLength }}
                    caracteres
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>

    <mat-divider></mat-divider>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>

        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formCorreccion.value"
            [disabled]="!formCorreccion.valid"
        >
            Enviar
        </button>
    </mat-dialog-actions>
</div>
